import { render, staticRenderFns } from "./staffdataupload.vue?vue&type=template&id=4452b50f&"
import script from "./staffdataupload.vue?vue&type=script&lang=ts&"
export * from "./staffdataupload.vue?vue&type=script&lang=ts&"
import style0 from "./staffdataupload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports